import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { deepExtract } from 'helpers/deep';
import { isEmpty } from 'helpers/verify';
import { timezoneDate } from 'helpers/time';
import { filterSetFilters } from 'redux/saga/selectors';
import { SEARCH } from 'constants/filter-sets';
import {
  setKeyword,
  setSelectedLocation,
  clearKeywordField,
  selectPreviousLocation,
  selectSelectedKeywordId,
} from '../SearchBox/SearchBox.reducer';
import { FILTER_NAMES } from '../Search.constants';
import { searchFilterActions } from './filters.helpers';
import { filterChanged, doAddActivityFilter } from './filters.saga';

const { clearFilter, setFilterValue } = searchFilterActions;

const { ACTIVITY, DATE, VERTICAL } = FILTER_NAMES;

export const selectActivityFilterAction = action => action.type === filterChanged().type && action.filter === ACTIVITY;

export const selectVerticalFilterAction = action =>
  action.type === setFilterValue().type && deepExtract('data.filter', action) === VERTICAL;

export function* doClearActivityFilter(excludeFromWriteActions = false) {
  const filters = yield select(filterSetFilters, SEARCH);
  if (!isEmpty(deepExtract(`${ACTIVITY}.itemIdSelected`, filters, {}))) {
    yield put(
      clearFilter(ACTIVITY, [], {
        excludeFromWriteActions,
      })
    );
  }
}

export function* doClearKeyword(excludeFromWriteActions = false) {
  if (yield select(selectSelectedKeywordId)) {
    yield put(
      clearKeywordField({
        excludeFromWriteActions,
      })
    );
  }
}

export function* doVerticalChange(action) {
  yield all([call(doClearActivityFilter, true), call(doAddActivityFilter), call(doClearKeyword, true)]);

  if (!deepExtract('data.options.excludeFromWriteActions', action)) {
    yield put(filterChanged());
  }
}

export function* doLocationChange({ location }) {
  const currentTimezone = location && location.timezone;
  const previousTimezone = deepExtract('timezone', yield select(selectPreviousLocation));

  if (currentTimezone && currentTimezone !== previousTimezone) {
    // We only care if the selected date is today in whichever timezone
    const today = timezoneDate(previousTimezone);
    const { date: filter } = yield select(filterSetFilters, SEARCH);
    const selected = (filter && filter.value) || today;

    if (today === selected) {
      yield put(setFilterValue(DATE, timezoneDate(currentTimezone)));
    }
  }
  yield put(filterChanged());
}

export function* watchInteractions() {
  yield takeLatest(setKeyword().type, doClearActivityFilter);
  yield takeLatest(setSelectedLocation().type, doLocationChange);
  yield takeLatest(selectActivityFilterAction, doClearKeyword, false);
  yield takeLatest(selectVerticalFilterAction, doVerticalChange);
}
